import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ModuleEntitlement {
  code: string;
  maxUsers: number | null;
  maxBeds: number | null;
  neoBeds: number | null;
  validUntil: string | null;
}

export interface LicenceEntitlements {
  modules: ModuleEntitlement[];
}

export interface LicenceUsage {
  basicBeds: number;
  neonatalBeds: number;
}

export interface LicenceWarning {
  code: string;
  message: string;
}

export interface LicenceStatus {
  entitlements: LicenceEntitlements;
  usage: LicenceUsage;
  warnings: LicenceWarning[];
}

export interface LicenceModuleStatus {
  code: string;
  enabled: boolean;
  available: boolean;
  reason: string | null;
}

export interface LicenceCertificateInfo {
  licenceId: string;
  licenceType: string;
  customer: string | null;
  issuedAt: string;
  validFrom: string;
  validUntil: string | null;
  maxUsers: number | null;
  maxBeds: number | null;
  neoBeds: number | null;
  isSignatureValid: boolean;
  isActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class LicensingApiService {
  private http = inject(HttpClient);

  getStatus(): Observable<LicenceStatus> {
    return this.http.get<LicenceStatus>('licences/status');
  }

  getCertificates(): Observable<LicenceCertificateInfo[]> {
    return this.http.get<LicenceCertificateInfo[]>('licences/certificates');
  }

  getModules(): Observable<LicenceModuleStatus[]> {
    return this.http.get<LicenceModuleStatus[]>('licences/modules');
  }

  addCertificate(licenceBase64: string): Observable<void> {
    return this.http.post<void>('licences/certificates', { licenceBase64 });
  }

  removeCertificate(licenceId: string): Observable<void> {
    return this.http.delete<void>(`licences/certificates/${licenceId}`);
  }
}
